var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": !_vm.dataForm.id ? 'Add Beneficial Owner' : 'Edit Beneficial Owner',
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "append-to-body": "",
      "width": "1100px",
      "top": "1vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "label-position": "top"
    }
  }, [_c('el-tabs', {
    attrs: {
      "stretch": ""
    },
    model: {
      value: _vm.dataForm.memberType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "memberType", $$v);
      },
      expression: "dataForm.memberType"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Company",
      "name": "CORPORATE"
    }
  }, [_vm.dataForm.memberType == 'CORPORATE' ? [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name (same as business certificate)",
      "prop": "fullName",
      "rules": {
        required: true,
        message: 'Please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Name"
    },
    model: {
      value: _vm.dataForm.fullName,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "fullName", $$v);
      },
      expression: "dataForm.fullName"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "country",
      "rules": {
        required: true,
        message: 'Please select',
        trigger: 'submit'
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Country"
    },
    model: {
      value: _vm.dataForm.country,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "country", $$v);
      },
      expression: "dataForm.country"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Business No.",
      "prop": "businessLicenseNo",
      "rules": {
        required: true,
        message: 'Please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "placeholder": "Business No."
    },
    model: {
      value: _vm.dataForm.businessLicenseNo,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "businessLicenseNo", $$v);
      },
      expression: "dataForm.businessLicenseNo"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mobile",
      "prop": "phone.code",
      "rules": [{
        required: _vm.businessType == 'COMPREHENSIVE_CUSTOMIZED' || _vm.businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
        message: 'Please enter',
        trigger: 'submit'
      }, {
        validator: _vm.validatePhone,
        trigger: 'submit'
      }]
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.numOrPointRegex,
      expression: "numOrPointRegex"
    }],
    staticClass: "input-with-select-xs",
    model: {
      value: _vm.dataForm.phone.code,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm.phone, "code", $$v);
      },
      expression: "dataForm.phone.code"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend",
    model: {
      value: _vm.dataForm.phone.prefix,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm.phone, "prefix", $$v);
      },
      expression: "dataForm.phone.prefix"
    }
  }, _vm._l(_vm.prefixOptions, function (single) {
    return _c('el-option', {
      key: single.title,
      attrs: {
        "value": single.value
      }
    }, [_vm._v(" " + _vm._s(single.value + " " + single.title) + " ")]);
  }), 1)], 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email",
      "rules": [{
        required: _vm.businessType == 'COMPREHENSIVE_CUSTOMIZED' || _vm.businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
        message: 'Please enter',
        trigger: 'submit'
      }, {
        type: 'email',
        message: 'Please provide a valid email address',
        trigger: 'submit'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: _vm.dataForm.email,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "email", $$v);
      },
      expression: "dataForm.email"
    }
  })], 1)], 1), !_vm.isMalaysia ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Registered Address",
      "prop": "registeredOfficeAddress",
      "rules": {
        required: true,
        message: 'Please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Company Registered Address"
    },
    model: {
      value: _vm.dataForm.registeredOfficeAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "registeredOfficeAddress", $$v);
      },
      expression: "dataForm.registeredOfficeAddress"
    }
  })], 1)], 1) : _vm._e(), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Operation Address",
      "prop": "operationAddress",
      "rules": {
        required: _vm.businessType == 'COMPREHENSIVE_CUSTOMIZED' || _vm.businessType == 'FUND_ADMIN_CUSTOMIZED' || _vm.businessType == 'COMPANY_INCORPORATION' ? false : true,
        message: 'Please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Company Operation Address"
    },
    model: {
      value: _vm.dataForm.operationAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "operationAddress", $$v);
      },
      expression: "dataForm.operationAddress"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "fluid-width",
    attrs: {
      "label": "Incorporation Date",
      "prop": "incorporationDate",
      "rules": {
        required: _vm.businessType == 'COMPREHENSIVE_CUSTOMIZED' || _vm.businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
        message: 'Please select',
        trigger: 'submit'
      }
    }
  }, [_c('el-date-picker', {
    staticClass: "fluid-width",
    attrs: {
      "type": "date",
      "placeholder": "Incorporation Date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: _vm.dataForm.incorporationDate,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "incorporationDate", $$v);
      },
      expression: "dataForm.incorporationDate"
    }
  })], 1)], 1), _vm.isMalaysia ? [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Entity Type",
      "prop": "entityType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Please select"
    },
    model: {
      value: _vm.dataForm.entityType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "entityType", $$v);
      },
      expression: "dataForm.entityType"
    }
  }, _vm._l(_vm.entityTypeList, function (item) {
    return _c('el-option', {
      key: "entityType".concat(item.value),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Registration Number",
      "prop": "companyRegistrationNumber",
      "rules": {
        required: true,
        message: 'Please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Registration Number"
    },
    model: {
      value: _vm.dataForm.companyRegistrationNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "companyRegistrationNumber", $$v);
      },
      expression: "dataForm.companyRegistrationNumber"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company Type",
      "prop": "companyType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Please select"
    },
    model: {
      value: _vm.dataForm.companyType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "companyType", $$v);
      },
      expression: "dataForm.companyType"
    }
  }, _vm._l(_vm.companyTypeList, function (item) {
    return _c('el-option', {
      key: "companyType".concat(item.value),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Place of Incorporation",
      "prop": "placeOfIncorporation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Place of Incorporation"
    },
    model: {
      value: _vm.dataForm.placeOfIncorporation,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "placeOfIncorporation", $$v);
      },
      expression: "dataForm.placeOfIncorporation"
    }
  })], 1)], 1), _c('el-col', {
    staticClass: "malaysia-address-block",
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "representativeWrap"
  }, [_vm._v("Registered Address")])]), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address Line 1",
      "prop": "registeredAddressLine1",
      "rules": {
        required: true,
        message: 'Please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Address Line 1"
    },
    model: {
      value: _vm.dataForm.registeredAddressLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "registeredAddressLine1", $$v);
      },
      expression: "dataForm.registeredAddressLine1"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address Line 2",
      "prop": "registeredAddressLine2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Address Line 2"
    },
    model: {
      value: _vm.dataForm.registeredAddressLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "registeredAddressLine2", $$v);
      },
      expression: "dataForm.registeredAddressLine2"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address Line 3",
      "prop": "registeredAddressLine3"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Address Line 3"
    },
    model: {
      value: _vm.dataForm.registeredAddressLine3,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "registeredAddressLine3", $$v);
      },
      expression: "dataForm.registeredAddressLine3"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "registeredAddressCity"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "City"
    },
    model: {
      value: _vm.dataForm.registeredAddressCity,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "registeredAddressCity", $$v);
      },
      expression: "dataForm.registeredAddressCity"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "registeredAddressState"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "State"
    },
    model: {
      value: _vm.dataForm.registeredAddressState,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "registeredAddressState", $$v);
      },
      expression: "dataForm.registeredAddressState"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Postal Code",
      "prop": "registeredAddressPostalCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Postal Code"
    },
    model: {
      value: _vm.dataForm.registeredAddressPostalCode,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "registeredAddressPostalCode", $$v);
      },
      expression: "dataForm.registeredAddressPostalCode"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "registeredAddressCountry"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Country",
      "filterable": ""
    },
    model: {
      value: _vm.dataForm.registeredAddressCountry,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "registeredAddressCountry", $$v);
      },
      expression: "dataForm.registeredAddressCountry"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: "regCountry".concat(item.value),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    staticClass: "malaysia-address-block",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "representativeWrap service-address-header"
  }, [_c('span', [_vm._v("Service Address")]), _c('el-checkbox', {
    attrs: {
      "true-label": 1,
      "false-label": 2
    },
    on: {
      "change": _vm.serviceAddressTypeChange
    },
    model: {
      value: _vm.dataForm.serviceAddressType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressType", $$v);
      },
      expression: "dataForm.serviceAddressType"
    }
  }, [_vm._v(" Same as Registered Address ")])], 1)]), _vm.dataForm.serviceAddressType !== 1 ? [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address Line 1",
      "prop": "serviceAddressLine1",
      "rules": {
        required: true,
        message: 'Please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Address Line 1"
    },
    model: {
      value: _vm.dataForm.serviceAddressLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressLine1", $$v);
      },
      expression: "dataForm.serviceAddressLine1"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address Line 2",
      "prop": "serviceAddressLine2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Address Line 2"
    },
    model: {
      value: _vm.dataForm.serviceAddressLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressLine2", $$v);
      },
      expression: "dataForm.serviceAddressLine2"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address Line 3",
      "prop": "serviceAddressLine3"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Address Line 3"
    },
    model: {
      value: _vm.dataForm.serviceAddressLine3,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressLine3", $$v);
      },
      expression: "dataForm.serviceAddressLine3"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "serviceAddressCity"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "City"
    },
    model: {
      value: _vm.dataForm.serviceAddressCity,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressCity", $$v);
      },
      expression: "dataForm.serviceAddressCity"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "serviceAddressState"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "State"
    },
    model: {
      value: _vm.dataForm.serviceAddressState,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressState", $$v);
      },
      expression: "dataForm.serviceAddressState"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Postal Code",
      "prop": "serviceAddressPostalCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Postal Code"
    },
    model: {
      value: _vm.dataForm.serviceAddressPostalCode,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressPostalCode", $$v);
      },
      expression: "dataForm.serviceAddressPostalCode"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "serviceAddressCountry"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Country",
      "filterable": ""
    },
    model: {
      value: _vm.dataForm.serviceAddressCountry,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressCountry", $$v);
      },
      expression: "dataForm.serviceAddressCountry"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: "svcCountry".concat(item.value),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1)] : _vm._e()] : _vm._e()], 2), _vm.dataForm.representativeInfo ? _c('div', [_c('p', {
    staticClass: "representativeWrap"
  }, [_vm._v("Representative")]), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name (same as IC)",
      "prop": "representativeInfo.fullName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Name"
    },
    model: {
      value: _vm.dataForm.representativeInfo.fullName,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm.representativeInfo, "fullName", $$v);
      },
      expression: "dataForm.representativeInfo.fullName"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nationality",
      "prop": "representativeInfo.nationality"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Nationality",
      "filterable": ""
    },
    model: {
      value: _vm.dataForm.representativeInfo.nationality,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm.representativeInfo, "nationality", $$v);
      },
      expression: "dataForm.representativeInfo.nationality"
    }
  }, _vm._l(_vm.nationalityList, function (item) {
    return _c('el-option', {
      key: "representativeInfoNationality".concat(item.value),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Identification Type",
      "prop": "representativeInfo.identificationType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select identificationType"
    },
    model: {
      value: _vm.dataForm.representativeInfo.identificationType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm.representativeInfo, "identificationType", $$v);
      },
      expression: "dataForm.representativeInfo.identificationType"
    }
  }, _vm._l(_vm.identificationTypeList, function (item) {
    return _c('el-option', {
      key: "representativeInfoIdCardType".concat(item.value),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Identification No.",
      "prop": "representativeInfo.identificationNo"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "placeholder": "Identification No."
    },
    model: {
      value: _vm.dataForm.representativeInfo.identificationNo,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm.representativeInfo, "identificationNo", $$v);
      },
      expression: "dataForm.representativeInfo.identificationNo"
    }
  })], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mobile No.",
      "prop": "representativeInfo.phone.code",
      "rules": [{
        validator: _vm.validateRepresentativePhone,
        trigger: 'submit'
      }]
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.numOrPointRegex,
      expression: "numOrPointRegex"
    }],
    staticClass: "input-with-select-xs",
    model: {
      value: _vm.dataForm.representativeInfo.phone.code,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm.representativeInfo.phone, "code", $$v);
      },
      expression: "dataForm.representativeInfo.phone.code"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend",
    model: {
      value: _vm.dataForm.representativeInfo.phone.prefix,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm.representativeInfo.phone, "prefix", $$v);
      },
      expression: "dataForm.representativeInfo.phone.prefix"
    }
  }, _vm._l(_vm.prefixOptions, function (single) {
    return _c('el-option', {
      key: "representativeInfoPrefix".concat(single.title),
      attrs: {
        "value": single.value
      }
    }, [_vm._v(" " + _vm._s(single.value + " " + single.title) + " ")]);
  }), 1)], 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "representativeInfo.email",
      "rules": [{
        type: 'email',
        message: 'Please provide a valid email address',
        trigger: 'submit'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: _vm.dataForm.representativeInfo.email,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm.representativeInfo, "email", $$v);
      },
      expression: "dataForm.representativeInfo.email"
    }
  })], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Residential address",
      "prop": "representativeInfo.residentialAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Residential address"
    },
    model: {
      value: _vm.dataForm.representativeInfo.residentialAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm.representativeInfo, "residentialAddress", $$v);
      },
      expression: "dataForm.representativeInfo.residentialAddress"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "fluid-width",
    attrs: {
      "label": "Birth Date",
      "prop": "representativeInfo.birthDate",
      "rules": [{
        validator: _vm.validateComeAge,
        trigger: 'submit'
      }]
    }
  }, [_c('el-date-picker', {
    staticClass: "fluid-width",
    attrs: {
      "type": "date",
      "placeholder": "Birth Date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: _vm.dataForm.representativeInfo.birthDate,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm.representativeInfo, "birthDate", $$v);
      },
      expression: "dataForm.representativeInfo.birthDate"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()] : _vm._e()], 2), _c('el-tab-pane', {
    attrs: {
      "label": "Individual",
      "name": "INDIVIDUAL"
    }
  }, [_vm.dataForm.memberType == 'INDIVIDUAL' ? [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name (same as IC)",
      "prop": "fullName",
      "rules": {
        required: true,
        message: 'Please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Name"
    },
    model: {
      value: _vm.dataForm.fullName,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "fullName", $$v);
      },
      expression: "dataForm.fullName"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nationality",
      "prop": "nationality",
      "rules": {
        required: true,
        message: 'Please select',
        trigger: 'submit'
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Nationality"
    },
    model: {
      value: _vm.dataForm.nationality,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "nationality", $$v);
      },
      expression: "dataForm.nationality"
    }
  }, _vm._l(_vm.nationalityList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Identification Type",
      "prop": "identificationType",
      "rules": {
        required: true,
        message: 'Please select',
        trigger: 'submit'
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select identificationType"
    },
    model: {
      value: _vm.dataForm.identificationType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "identificationType", $$v);
      },
      expression: "dataForm.identificationType"
    }
  }, _vm._l(_vm.identificationTypeList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Identification No.",
      "prop": "identificationNo",
      "rules": {
        required: true,
        message: 'Please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "placeholder": "Identification No."
    },
    model: {
      value: _vm.dataForm.identificationNo,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "identificationNo", $$v);
      },
      expression: "dataForm.identificationNo"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mobile",
      "prop": "phone.code",
      "rules": [{
        required: _vm.businessType == 'COMPREHENSIVE_CUSTOMIZED' || _vm.businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
        message: 'Please enter',
        trigger: 'submit'
      }, {
        validator: _vm.validatePhone,
        trigger: 'submit'
      }]
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.numOrPointRegex,
      expression: "numOrPointRegex"
    }],
    staticClass: "input-with-select-xs",
    model: {
      value: _vm.dataForm.phone.code,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm.phone, "code", $$v);
      },
      expression: "dataForm.phone.code"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend",
    model: {
      value: _vm.dataForm.phone.prefix,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm.phone, "prefix", $$v);
      },
      expression: "dataForm.phone.prefix"
    }
  }, _vm._l(_vm.prefixOptions, function (single) {
    return _c('el-option', {
      key: single.title,
      attrs: {
        "value": single.value
      }
    }, [_vm._v(" " + _vm._s(single.value + " " + single.title) + " ")]);
  }), 1)], 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email",
      "rules": [{
        required: _vm.businessType == 'COMPREHENSIVE_CUSTOMIZED' || _vm.businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
        message: 'Please enter',
        trigger: 'submit'
      }, {
        type: 'email',
        message: 'Please provide a valid email address',
        trigger: 'submit'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: _vm.dataForm.email,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "email", $$v);
      },
      expression: "dataForm.email"
    }
  })], 1)], 1), !_vm.isMalaysia ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Residential address",
      "prop": "residentialAddress",
      "rules": {
        required: true,
        message: 'Please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Residential address"
    },
    model: {
      value: _vm.dataForm.residentialAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "residentialAddress", $$v);
      },
      expression: "dataForm.residentialAddress"
    }
  })], 1)], 1) : _vm._e(), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "fluid-width",
    attrs: {
      "label": "Birth Date",
      "prop": "birthDate",
      "rules": [{
        required: _vm.businessType == 'COMPREHENSIVE_CUSTOMIZED' || _vm.businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
        message: 'Please select',
        trigger: 'submit'
      }, {
        validator: _vm.validateComeAge,
        trigger: 'submit'
      }]
    }
  }, [_c('el-date-picker', {
    staticClass: "fluid-width",
    attrs: {
      "type": "date",
      "placeholder": "Birth Date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: _vm.dataForm.birthDate,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "birthDate", $$v);
      },
      expression: "dataForm.birthDate"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Does the individual hold share interest of any entity in PRC inland?",
      "prop": "isHoldShareOfPrcInland",
      "rules": {
        required: true,
        message: 'Please select',
        trigger: 'submit'
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Please select"
    },
    model: {
      value: _vm.dataForm.isHoldShareOfPrcInland,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "isHoldShareOfPrcInland", $$v);
      },
      expression: "dataForm.isHoldShareOfPrcInland"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Yes",
      "value": 1
    }
  }), _c('el-option', {
    attrs: {
      "label": "No",
      "value": 0
    }
  })], 1)], 1)], 1), _vm.dataForm.isHoldShareOfPrcInland ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "fluid-width",
    attrs: {
      "label": "Please provide the name of RPC entity (1 entity is required)",
      "prop": "holdShareOfPrcEntity",
      "rules": {
        required: true,
        message: 'Please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Please enter"
    },
    model: {
      value: _vm.dataForm.holdShareOfPrcEntity,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "holdShareOfPrcEntity", $$v);
      },
      expression: "dataForm.holdShareOfPrcEntity"
    }
  })], 1)], 1) : _vm._e(), _vm.isMalaysia ? [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Gender",
      "prop": "gender",
      "rules": {
        required: true,
        message: 'Please select',
        trigger: 'submit'
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Please select"
    },
    model: {
      value: _vm.dataForm.gender,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "gender", $$v);
      },
      expression: "dataForm.gender"
    }
  }, _vm._l(_vm.genderTypeList, function (item) {
    return _c('el-option', {
      key: "gender".concat(item.value),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Occupation",
      "prop": "occupation",
      "rules": {
        required: true,
        message: 'Please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Occupation"
    },
    model: {
      value: _vm.dataForm.occupation,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "occupation", $$v);
      },
      expression: "dataForm.occupation"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Race",
      "prop": "race",
      "rules": {
        required: true,
        message: 'Please select',
        trigger: 'submit'
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Please select",
      "filterable": ""
    },
    model: {
      value: _vm.dataForm.race,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "race", $$v);
      },
      expression: "dataForm.race"
    }
  }, _vm._l(_vm.raceTypeList, function (item) {
    return _c('el-option', {
      key: "race".concat(item.value),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    staticClass: "malaysia-address-block",
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "representativeWrap"
  }, [_vm._v("Residential Address")])]), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address Line 1",
      "prop": "residentialAddressLine1",
      "rules": {
        required: true,
        message: 'Please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Address Line 1"
    },
    model: {
      value: _vm.dataForm.residentialAddressLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "residentialAddressLine1", $$v);
      },
      expression: "dataForm.residentialAddressLine1"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address Line 2",
      "prop": "residentialAddressLine2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Address Line 2"
    },
    model: {
      value: _vm.dataForm.residentialAddressLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "residentialAddressLine2", $$v);
      },
      expression: "dataForm.residentialAddressLine2"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address Line 3",
      "prop": "residentialAddressLine3"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Address Line 3"
    },
    model: {
      value: _vm.dataForm.residentialAddressLine3,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "residentialAddressLine3", $$v);
      },
      expression: "dataForm.residentialAddressLine3"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "residentialAddressCity"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "City"
    },
    model: {
      value: _vm.dataForm.residentialAddressCity,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "residentialAddressCity", $$v);
      },
      expression: "dataForm.residentialAddressCity"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "residentialAddressState"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "State"
    },
    model: {
      value: _vm.dataForm.residentialAddressState,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "residentialAddressState", $$v);
      },
      expression: "dataForm.residentialAddressState"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Postal Code",
      "prop": "residentialAddressPostalCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Postal Code"
    },
    model: {
      value: _vm.dataForm.residentialAddressPostalCode,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "residentialAddressPostalCode", $$v);
      },
      expression: "dataForm.residentialAddressPostalCode"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "residentialAddressCountry"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Country",
      "filterable": ""
    },
    model: {
      value: _vm.dataForm.residentialAddressCountry,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "residentialAddressCountry", $$v);
      },
      expression: "dataForm.residentialAddressCountry"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: "resCountry".concat(item.value),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    staticClass: "malaysia-address-block",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "representativeWrap service-address-header"
  }, [_c('span', [_vm._v("Service Address")]), _c('el-checkbox', {
    attrs: {
      "true-label": 1,
      "false-label": 2
    },
    on: {
      "change": _vm.serviceAddressTypeChange
    },
    model: {
      value: _vm.dataForm.serviceAddressType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressType", $$v);
      },
      expression: "dataForm.serviceAddressType"
    }
  }, [_vm._v(" Same as Residential Address ")])], 1)]), _vm.dataForm.serviceAddressType !== 1 ? [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address Line 1",
      "prop": "serviceAddressLine1",
      "rules": {
        required: true,
        message: 'Please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Address Line 1"
    },
    model: {
      value: _vm.dataForm.serviceAddressLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressLine1", $$v);
      },
      expression: "dataForm.serviceAddressLine1"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address Line 2",
      "prop": "serviceAddressLine2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Address Line 2"
    },
    model: {
      value: _vm.dataForm.serviceAddressLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressLine2", $$v);
      },
      expression: "dataForm.serviceAddressLine2"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address Line 3",
      "prop": "serviceAddressLine3"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Address Line 3"
    },
    model: {
      value: _vm.dataForm.serviceAddressLine3,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressLine3", $$v);
      },
      expression: "dataForm.serviceAddressLine3"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "serviceAddressCity"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "City"
    },
    model: {
      value: _vm.dataForm.serviceAddressCity,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressCity", $$v);
      },
      expression: "dataForm.serviceAddressCity"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "serviceAddressState"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "State"
    },
    model: {
      value: _vm.dataForm.serviceAddressState,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressState", $$v);
      },
      expression: "dataForm.serviceAddressState"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Postal Code",
      "prop": "serviceAddressPostalCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Postal Code"
    },
    model: {
      value: _vm.dataForm.serviceAddressPostalCode,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressPostalCode", $$v);
      },
      expression: "dataForm.serviceAddressPostalCode"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "serviceAddressCountry"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Country",
      "filterable": ""
    },
    model: {
      value: _vm.dataForm.serviceAddressCountry,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceAddressCountry", $$v);
      },
      expression: "dataForm.serviceAddressCountry"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: "svcCountry".concat(item.value),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1)] : _vm._e()] : _vm._e()], 2)] : _vm._e()], 2)], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.dataFormSubmit();
      }
    }
  }, [_vm._v("OK")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }